const MYCONF = {
    // 后台接口主域名
    api_host:'https://api.cdbcck.com',
    appid:'wxc373be0ebd319f82'
    // wx219abaf1a638ac95

    // api_host:'http://192.168.2.27:8088',
    // appid:'wxde8e9d42965bddff'
    // appid:'wxc373be0ebd319f82'
    // 测试号appid
}

export default MYCONF

// 测试号地址
// https://mp.weixin.qq.com/debug/cgi-bin/sandboxinfo?action=showinfo&t=sandbox/index